NtechApp.JobSendGlobalResumeManager = function() {
    var me = this;

    this._ajax = null;
    this._click = null;
    this._form = null;

    this._construct = function() {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();
        me._form = new NtechApp.ModalForm();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen($("body"), "[data-triggerSendGlobalResume]", function(event) {
            if(!NtechApp.clientSettings.isPersonal) {
                NtechApp.info.on("Only personal accounts can send resumes to jobs.", 2500);
                return;
            }

            var $control = $(event.target).closest("[data-triggerSendGlobalResume]");
            var jobsCount = parseInt($control.attr("data-jobsCount"), 10);
            var businessAccId = $control.attr("data-triggerSendGlobalResume");

            if(jobsCount == 0) {
                NtechApp.info.on("Restaurant has no opened positions now.");
                return;
            }

            if($control.hasClass("lockedButton"))
                return;

            $control.addClass("lockedButton");
            me._loadSendGlobalResumeForm(businessAccId, $control);
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.JobSendGlobalResumeManager, {
    _loadSendGlobalResumeForm: function(businessAccId, $item) {
        var me = this;
        var params = {
            businessAccountId: businessAccId
        };

        me._form.load("personal_load_global_send_resume_form", params, function($form) {
            $item.removeClass("lockedButton");

            me._click.listen($form, "[data-closeForm]", function(e) {
                me._form.unload();
            });
        });
    }
});